import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Routes, Route, Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import './App.css';

// --- 1. ASSETS (ICONS & LOGOS IN CODE) ---

const Icons = {
    Logo: () => (
        <svg viewBox="0 0 24 24" className="svg-logo" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 12h5" />
            <path d="M4 12v-3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3" />
            <circle cx="14" cy="12" r="2" />
            <path d="M22 12h-1" />
        </svg>
    ),
    WhatsApp: () => (
        <svg viewBox="0 0 24 24" className="svg-social" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
    ),
    Instagram: () => (
        <svg viewBox="0 0 24 24" className="svg-social" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
        </svg>
    )
};

// --- 2. DYNAMIC SPONSOR BANNER ---

function SponsorBanner({ type }) {
    const styles = {
        MENS: {
            background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
            color: "white",
            icon: "⚡",
            text: "Official Mens Sponsor: PowerServe Energy"
        },
        WOMENS: {
            background: "linear-gradient(135deg, #be185d 0%, #ec4899 100%)",
            color: "white",
            icon: "🌸",
            text: "Official Womens Sponsor: CourtQueens"
        },
        MIX: {
            background: "linear-gradient(135deg, #047857 0%, #10b981 100%)",
            color: "white",
            icon: "🎾",
            text: "Official Mix Sponsor: DuoSports"
        }
    };

    const style = styles[type] || { background: "#cbd5e1", color: "#334155", icon: "🤝", text: "Proud League Sponsor" };

    return (
        <div className="sponsor-banner" style={{ background: style.background, color: style.color }}>
            <div className="sponsor-content">
                <span className="sponsor-icon">{style.icon}</span>
                <span className="sponsor-text">{style.text}</span>
            </div>
        </div>
    );
}

// --- 3. SHARED COMPONENTS ---

function Navbar({ token, username, onLogout }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setIsMenuOpen(false); }, [location]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-header">
            <Link to="/" className="logo-link">
                <Icons.Logo />
                <span className="logo-text">LIFT TENNIS</span>
            </Link>
            <button className="hamburger-btn" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                {isMenuOpen ? '✕' : '☰'}
            </button>
        </div>
        
        <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/leagues" className="nav-link">Leagues</Link>
            <Link to="/rankings" className="nav-link">Rankings</Link>
            {/* REMOVED DUPLICATE PROFILE LINK HERE */}
            
            {token ? (
                <button className="nav-btn logout mobile-only" onClick={onLogout}>Logout ({username})</button>
            ) : (
                <Link to="/login" className="nav-btn mobile-only">Login</Link>
            )}
        </div>

        <div className="navbar-auth desktop-only">
            {token ? (
                <div style={{display:'flex', gap:'10px', alignItems:'center'}}>
                    <Link to="/profile" style={{color:'#94a3b8', textDecoration:'none', fontWeight:'600', marginRight:'10px'}}>Profile</Link>
                    <button className="nav-btn logout" onClick={onLogout}>Logout ({username})</button>
                </div>
            ) : (
                <Link to="/login" className="nav-btn">Login / Sign Up</Link>
            )}
        </div>
      </div>
    </nav>
  );
}

function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-copyright">
                    &copy; {currentYear} Bart van Rooijen. All rights reserved.
                </div>
                <div className="footer-socials">
                    <a href="https://wa.me/" target="_blank" rel="noopener noreferrer" className="social-link">
                        <Icons.WhatsApp />
                    </a>
                    <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" className="social-link">
                        <Icons.Instagram />
                    </a>
                </div>
            </div>
        </footer>
    );
}

// --- 4. PAGE COMPONENTS ---

function HomePage() {
  useEffect(() => { document.title = "Home | Lift Tennis"; }, []);

  return (
    <div className="home-page">
      <div className="hero-section">
        <h1>Welcome to Lift Beach Tennis</h1>
        <p>Join the ultimate league experience. Track your progress, view brackets, and climb the rankings.</p>
        <div className="hero-buttons">
            <Link to="/leagues" className="primary-btn">Browse Leagues</Link>
            <Link to="/rankings" className="secondary-btn">Global Rankings</Link>
        </div>
      </div>
      <div className="features-grid">
          <div className="feature-card">
              <h3>🏆 Competitive Leagues</h3>
              <p>Join Men's, Women's, and Mix doubles leagues tailored to your skill level.</p>
          </div>
          <div className="feature-card">
              <h3>📊 Live Brackets</h3>
              <p>Follow tournament progress in real-time with our automated bracket system.</p>
          </div>
          <div className="feature-card">
              <h3>📈 Global Rankings</h3>
              <p>Earn points for every match and see where you stand against the community.</p>
          </div>
      </div>
    </div>
  );
}

function RankingsPage() {
  const [rankings, setRankings] = useState([]);
  const [rankType, setRankType] = useState('MENS');
  const [rankClass, setRankClass] = useState('GOLD');

  useEffect(() => { document.title = "Global Rankings | Lift Tennis"; }, []);

  useEffect(() => {
      axios.get(`/api/rankings/?type=${rankType}&classification=${rankClass}`)
        .then(res => setRankings(res.data))
        .catch(err => console.error(err));
  }, [rankType, rankClass]);

  return (
    <div className="page-container">
        <div className="detail-header">
            <h2>🏆 Global Rankings</h2>
        </div>
        
        <div className="filters">
            <select value={rankType} onChange={e => setRankType(e.target.value)}>
                <option value="MENS">Men's Doubles</option>
                <option value="WOMENS">Women's Doubles</option>
                <option value="MIX">Mix Doubles</option>
            </select>
            <select value={rankClass} onChange={e => setRankClass(e.target.value)}>
                <option value="PLATINUM">Platinum</option>
                <option value="GOLD">Gold</option>
                <option value="SILVER">Silver</option>
                <option value="BRONZE">Bronze</option>
            </select>
        </div>

        <div className="ranking-table-card">
            <table className="ranking-table">
                <thead>
                    <tr>
                        <th width="10%">#</th>
                        <th>Player</th>
                        <th width="20%">Points</th>
                    </tr>
                </thead>
                <tbody>
                    {rankings.length > 0 ? rankings.map((r, index) => (
                        <tr key={r.id}>
                            <td><span className={`rank-num rank-${index+1}`}>{index + 1}</span></td>
                            <td>{r.player.user.first_name} {r.player.user.last_name}</td>
                            <td><strong>{r.points}</strong></td>
                        </tr>
                    )) : (
                        <tr><td colSpan="3" style={{textAlign:'center', padding:'20px'}}>No rankings yet for this category.</td></tr>
                    )}
                </tbody>
            </table>
        </div>
    </div>
  );
}

function LeaguesListPage({ token }) {
  const [leagues, setLeagues] = useState([]);
  const navigate = useNavigate();

  useEffect(() => { document.title = "Leagues | Lift Tennis"; }, []);

  useEffect(() => {
    axios.get('/api/leagues/')
      .then(res => setLeagues(res.data))
      .catch(err => console.error(err));
  }, []);

  const formatDate = (dateString) => {
      if (!dateString) return "";
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="page-container">
        <div className="detail-header">
            <h2>Available Leagues</h2>
        </div>
        <div className="league-list">
        {leagues.map(l => (
            <div key={l.id} className="league-card">
                <div className="card-top">
                    <h3>{l.name}</h3>
                </div>
                <div className="card-badges-row">
                    <span className={`badge ${l.classification}`}>{l.classification}</span>
                    <span className="badge-type">{l.league_type}</span>
                    <span className="badge-date">{formatDate(l.start_date)}</span>
                    <span className={`badge ${l.points_applied ? 'FINISHED' : (l.is_registration_open ? 'OPEN' : 'LIVE')}`}>
                        {l.points_applied ? 'FINISHED' : (l.is_registration_open ? 'OPEN' : 'LIVE')}
                    </span>
                </div>
                
                <SponsorBanner type={l.league_type} />
                
                <div className="card-actions">
                    <button className="secondary-btn full-width" onClick={() => navigate(`/leagues/${l.id}`)}>
                        View League
                    </button>
                </div>
            </div>
        ))}
        </div>
    </div>
  );
}

function LeagueDetailPage({ token, username }) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [league, setLeague] = useState(null);
    const [viewMode, setViewMode] = useState('overview'); 
    const [partnerName, setPartnerName] = useState('');
    const [msg, setMsg] = useState({ text: '', type: '' });

    useEffect(() => { fetchLeague(); }, [id]);

    useEffect(() => {
        if (league) document.title = `${league.name} | Lift Tennis`;
    }, [league]);

    useEffect(() => {
        if (msg.text) {
            const timer = setTimeout(() => setMsg({ text: '', type: '' }), 3000);
            return () => clearTimeout(timer);
        }
    }, [msg]);

    const fetchLeague = () => {
        axios.get(`/api/leagues/${id}/`)
            .then(res => setLeague(res.data))
            .catch(err => console.error(err));
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const handleJoin = () => {
        if (!token) return navigate('/login');
        axios.post(`/api/leagues/${id}/join/`, { partner_username: partnerName })
          .then(res => { setMsg({ text: res.data.message, type: "success" }); fetchLeague(); })
          .catch(err => setMsg({ text: err.response?.data?.error || "Failed", type: "error" }));
    };
    
    const handleLeave = () => {
        if(!window.confirm("Leave this league?")) return;
        axios.post(`/api/leagues/${id}/leave/`)
          .then(res => { setMsg({ text: res.data.message, type: "success" }); fetchLeague(); })
          .catch(err => setMsg({ text: "Error", type: "error" }));
    };

    const isRegistered = () => {
        if (!league || !username || !league.registrations) return false;
        return league.registrations.some(r => 
           r.team.player_1_details.user.username === username || 
           (r.team.player_2_details && r.team.player_2_details.user.username === username)
        );
    };

    const getTeamName = (team) => {
        if (!team) return "TBD";
        const p1 = `${team.player_1_details.user.first_name} ${team.player_1_details.user.last_name}`;
        const p2 = team.player_2_details ? `${team.player_2_details.user.first_name} ${team.player_2_details.user.last_name}` : "";
        return p2 ? `${p1} & ${p2}` : p1;
    };

    const organizeBracket = (matches) => {
        if (!matches || matches.length === 0) return {};
        const rounds = {};
        matches.forEach(m => {
            if (!rounds[m.round_number]) rounds[m.round_number] = [];
            rounds[m.round_number].push(m);
        });
        Object.keys(rounds).forEach(key => rounds[key].sort((a, b) => a.match_order - b.match_order));
        return rounds;
    };
  
    const getRoundName = (roundNum) => {
        if (roundNum === 1) return "Final";
        if (roundNum === 2) return "Semi Finals";
        if (roundNum === 3) return "Quarter Finals";
        return `Round ${roundNum}`;
    };

    if (!league) return <div className="page-container">Loading...</div>;

    return (
        <div className="page-container">
            {msg.text && <div className={`alert ${msg.type}`}>{msg.text}</div>}
            
            <div className="detail-header">
                <button className="back-btn" onClick={() => navigate('/leagues')}>← Back to Leagues</button>
                <div className="header-title-row">
                    <h2>{league.name}</h2>
                    <span className={`badge ${league.classification}`}>{league.classification}</span>
                    <span className="badge-type">{league.league_type}</span>
                    <span className="badge-date" style={{marginLeft:'auto'}}>{formatDate(league.start_date)}</span>
                </div>
                
                {/* NEW: Display Entry Fee */}
                <div style={{marginTop:'0.5rem', color:'#64748b', fontWeight:'500', fontSize:'0.9rem'}}>
                    Entry Fee: {league.currency} {league.entry_fee}
                </div>
            </div>

            <div className="tabs">
                <button className={viewMode==='overview'?'active':''} onClick={()=>setViewMode('overview')}>Overview</button>
                {league.groups?.length > 0 && (
                    <button className={viewMode==='groups'?'active':''} onClick={()=>setViewMode('groups')}>Groups</button>
                )}
                {(league.bracket_generated || (league.bracket_matches && league.bracket_matches.length > 0)) && (
                    <button className={viewMode==='brackets'?'active':''} onClick={()=>setViewMode('brackets')}>Bracket</button>
                )}
                {league.results && league.results.length > 0 && (
                    <button className={viewMode==='results'?'active':''} onClick={()=>setViewMode('results')}>Results</button>
                )}
            </div>

            {viewMode === 'overview' && (
                <div className="overview-tab">
                    <div className="action-card">
                        {isRegistered() ? (
                            <div className="status-registered">
                                <p>✅ You are in!</p>
                                {league.is_registration_open && <button className="danger-btn" onClick={handleLeave}>Leave League</button>}
                            </div>
                        ) : league.is_registration_open ? (
                            <div className="join-form">
                                <input placeholder="Partner Username (Leave empty for solo)" onChange={e=>setPartnerName(e.target.value)} />
                                <button className="primary-btn" onClick={handleJoin}>Join League</button>
                            </div>
                        ) : (
                            <div className="status-box closed"><p>🔒 Registration Closed</p></div>
                        )}
                    </div>
                    
                    <h3 className="section-title">Registered Teams ({league.registrations?.length || 0})</h3>
                    <div className="content-card">
                        <div className="team-grid">
                            {league.registrations?.map(r => (
                                <div key={r.id} className="team-chip">{getTeamName(r.team)}</div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {viewMode === 'groups' && (
                <div className="groups-tab">
                    <div className="groups-grid">
                        {league.groups.map(g => (
                            <div key={g.id} className="group-card">
                                <div className="group-header">Group {g.name}</div>
                                <div className="group-matches">
                                    {g.matches && g.matches.length > 0 ? (
                                        g.matches.map(m => (
                                            <div key={m.id} className="match-row">
                                                <div className="match-teamname">{getTeamName(m.team_a_details)}</div>
                                                <div className="match-center">
                                                    {m.is_finished ? (
                                                        <span className="score-finished">{m.games_a} - {m.games_b}</span>
                                                    ) : <span className="score-vs">vs</span>}
                                                </div>
                                                <div className="match-teamname right">{getTeamName(m.team_b_details)}</div>
                                            </div>
                                        ))
                                    ) : <p className="no-matches">No matches scheduled</p>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {viewMode === 'brackets' && (
                <div className="brackets-tab">
                    {(!league.bracket_matches || league.bracket_matches.length === 0) ? (
                         <div className="empty-state">Bracket generation in progress...</div>
                    ) : (
                        <div className="content-card scroll-container">
                            <div className="bracket-container">
                                {Object.keys(organizeBracket(league.bracket_matches))
                                    .sort((a,b) => b - a) 
                                    .map(roundNum => (
                                    <div key={roundNum} className="bracket-column">
                                        <h4 className="round-title">{getRoundName(parseInt(roundNum))}</h4>
                                        <div className="round-matches">
                                            {organizeBracket(league.bracket_matches)[roundNum].map(m => (
                                                <div key={m.id} className="bracket-match-card">
                                                    <div className={`bm-team ${m.winner === m.team_a ? 'winner' : ''} ${!m.team_a ? 'bye' : ''}`}>
                                                        <span>{m.team_a_details ? getTeamName(m.team_a_details) : (m.is_bye ? 'BYE' : 'TBD')}</span>
                                                        {m.team_a_details && <span className="bm-score">{m.games_a}</span>}
                                                    </div>
                                                    <div className={`bm-team ${m.winner === m.team_b ? 'winner' : ''} ${!m.team_b ? 'bye' : ''}`}>
                                                        <span>{m.team_b_details ? getTeamName(m.team_b_details) : (m.is_bye ? 'BYE' : 'TBD')}</span>
                                                        {m.team_b_details && <span className="bm-score">{m.games_b}</span>}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )}

            {viewMode === 'results' && (
                 <div className="results-tab">
                    <div className="ranking-table-card">
                        <table className="ranking-table">
                            <thead>
                                <tr>
                                    <th>Rank</th>
                                    <th>Team</th>
                                    <th>Stage</th>
                                    <th>Points</th>
                                </tr>
                            </thead>
                            <tbody>
                                {league.results.map((r, i) => (
                                    <tr key={r.id}>
                                        <td>{i+1}</td>
                                        <td>{getTeamName(r.team)}</td>
                                        <td>{r.stage_reached}</td>
                                        <td>+{r.points_awarded}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                 </div>
            )}
        </div>
    );
}

function LoginPage({ setIsLoggedIn, setUsername }) {
    const [isLoginMode, setIsLoginMode] = useState(true);
    const [authData, setAuthData] = useState({ 
      username: '', password: '', confirmPassword: '', 
      email: '', first_name: '', last_name: '', phone: '' 
    });
    const [msg, setMsg] = useState({ text: '', type: '' });
    const navigate = useNavigate();

    useEffect(() => { document.title = "Login | Lift Tennis"; }, []);

    // Auto-clear messages
    useEffect(() => {
        if (msg.text) {
            const timer = setTimeout(() => setMsg({ text: '', type: '' }), 3000);
            return () => clearTimeout(timer);
        }
    }, [msg]);

    const handleAuth = (e) => {
        e.preventDefault();
        setMsg({ text: '', type: '' });
    
        if (!isLoginMode) {
            if (authData.password !== authData.confirmPassword) {
                setMsg({ text: "Passwords do not match!", type: "error" });
                return;
            }
            if (!authData.phone || !authData.first_name || !authData.last_name) {
                 setMsg({ text: "Please fill in all fields.", type: "error" });
                 return;
            }
        }
    
        const url = isLoginMode ? '/api/login/' : '/api/register/';
        axios.post(url, authData)
            .then(res => {
                localStorage.setItem('lift_token', res.data.token);
                localStorage.setItem('lift_user', res.data.username);
                setIsLoggedIn(true);
                setUsername(res.data.username);
                navigate('/leagues'); // Redirect to leagues after login
            })
            .catch(err => {
                const errorMsg = err.response?.data?.error || JSON.stringify(err.response?.data) || "Auth Failed";
                setMsg({ text: errorMsg, type: "error" });
            });
    };

    return (
        <div className="container">
            {msg.text && <div className={`alert ${msg.type}`}>{msg.text}</div>}
            <div className="auth-box">
                <h2>{isLoginMode ? "Login" : "Join the League"}</h2>
                <form onSubmit={handleAuth}>
                    <input placeholder="Username" onChange={e=>setAuthData({...authData, username:e.target.value})} required />
                    <input type="password" placeholder="Password" onChange={e=>setAuthData({...authData, password:e.target.value})} required />
                    
                    {!isLoginMode && (
                        <>
                            <input type="password" placeholder="Confirm Password" onChange={e=>setAuthData({...authData, confirmPassword:e.target.value})} required />
                            <input placeholder="Email" type="email" onChange={e=>setAuthData({...authData, email:e.target.value})} required />
                            <div className="grid-2">
                                <input placeholder="First Name" onChange={e=>setAuthData({...authData, first_name:e.target.value})} required />
                                <input placeholder="Last Name" onChange={e=>setAuthData({...authData, last_name:e.target.value})} required />
                            </div>
                            <input placeholder="Phone Number" onChange={e=>setAuthData({...authData, phone:e.target.value})} required />
                        </>
                    )}
                    
                    <button className="primary-btn full-width">{isLoginMode ? "Login" : "Create Account"}</button>
                </form>
                <p className="auth-switch" onClick={() => setIsLoginMode(!isLoginMode)}>
                    {isLoginMode ? "New here? Create an account" : "Already have an account? Login"}
                </p>
            </div>
        </div>
    );
}

// --- 5. PROFILE PAGE ---
function ProfilePage({ token }) {
    const [passwords, setPasswords] = useState({ old_password: '', new_password: '', confirm_new: '' });
    const [msg, setMsg] = useState({ text: '', type: '' });
    const navigate = useNavigate();

    useEffect(() => { if (!token) navigate('/login'); }, [token, navigate]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (passwords.new_password !== passwords.confirm_new) {
            setMsg({ text: "New passwords do not match.", type: "error" });
            return;
        }

        axios.post('/api/change-password/', {
            old_password: passwords.old_password,
            new_password: passwords.new_password
        })
        .then(res => {
            setMsg({ text: "Password updated successfully!", type: "success" });
            setPasswords({ old_password: '', new_password: '', confirm_new: '' });
        })
        .catch(err => {
            const errorData = err.response?.data;
            const errorMsg = errorData?.old_password ? errorData.old_password[0] : 
                             (errorData?.new_password ? errorData.new_password[0] : "Failed to update password.");
            setMsg({ text: errorMsg, type: "error" });
        });
    };

    return (
        <div className="container">
            {msg.text && <div className={`alert ${msg.type}`}>{msg.text}</div>}
            <div className="auth-box">
                <h2>Change Password</h2>
                <form onSubmit={handleSubmit}>
                    <input 
                        type="password" 
                        placeholder="Current Password" 
                        value={passwords.old_password}
                        onChange={e=>setPasswords({...passwords, old_password:e.target.value})} 
                        required 
                    />
                    <input 
                        type="password" 
                        placeholder="New Password (Min 8 chars, 1 number, 1 uppercase)" 
                        value={passwords.new_password}
                        onChange={e=>setPasswords({...passwords, new_password:e.target.value})} 
                        required 
                    />
                    <input 
                        type="password" 
                        placeholder="Confirm New Password" 
                        value={passwords.confirm_new}
                        onChange={e=>setPasswords({...passwords, confirm_new:e.target.value})} 
                        required 
                    />
                    <button className="primary-btn full-width">Update Password</button>
                </form>
            </div>
        </div>
    );
}


// --- 6. MAIN APP ROUTER ---

function App() {
  const [token, setToken] = useState(localStorage.getItem('lift_token'));
  const [username, setUsername] = useState(localStorage.getItem('lift_user'));

  if (token) axios.defaults.headers.common['Authorization'] = `Token ${token}`;

  const handleLogout = () => {
      localStorage.clear();
      setToken(null);
      setUsername(null);
      window.location.href = '/'; 
  };

  return (
    <Router>
      <div className="app">
        <Navbar token={token} username={username} onLogout={handleLogout} />
        <div className="main-content">
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/leagues" element={<LeaguesListPage token={token} />} />
                <Route path="/leagues/:id" element={<LeagueDetailPage token={token} username={username} />} />
                <Route path="/rankings" element={<RankingsPage />} />
                <Route path="/login" element={<LoginPage setIsLoggedIn={(val) => setToken(localStorage.getItem('lift_token'))} setUsername={setUsername} />} />
                <Route path="/profile" element={<ProfilePage token={token} />} />
            </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;